export default __webpack_public_path__ + "static/media/@yasminportela.6eaa6ce7.png";